import React from 'react';
import styled from 'astroturf/react';

import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';
import routes, { RouteOptions } from 'js/core_pre_webpack/routes';

import { CourseCard, CarouselProps } from '../shared/Carousel';

interface Props {
  carousel: CarouselProps;
}

const Header = styled.h2`
  @import '../shared/mixins.scss';
  @include subheadBold();
  margin-top: 0;
  margin-bottom: 20px;
  color: #222222;
  opacity: 0.9;
`;

const CoursesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  grid-column-gap: 16px;
  grid-row-gap: 32px;
  margin-bottom: 34px;
`;

const Link = styled.a`
  &:hover,
  &:focus {
    text-decoration: none;
  }
`;

const ViewMoreButton = styled.button`
  @import '../shared/mixins.scss';
  @include button(secondary);
  height: 48px;
`;

const NewCourses: React.FunctionComponent<Props> = ({ carousel }) => {
  const { categoryTitle, courses, page } = carousel;
  const moreCoursesUrlParams: RouteOptions = {};

  const items = courses.slice(0, 3).map((course, index) => {
    const category = categoryTitle.toLowerCase().replace(/[^\w]+/g, '_');
    return (
      <ImpressionWatcher
        source={category}
        entity_type={9}
        entity_id={course.courseId}
        extra={{
          position: index,
          page: page,
          ...course.impressionData,
        }}
        // The CourseCard is rather large and contains the thumbnail, title, instructor, etc.
        // Assuming that the user is scrolling from the top of the page, a threshold of 40% will
        // mean that most of the thumbnail should be displayed in the viewport. Anything less than
        // that will not be registered as an impression and any clicks to the CourseCard in that
        // scenario shall be regarded as an accidental click.
        threshold={0.4}
        key={course.courseId}
      >
        <CourseCard
          courseId={course.courseId}
          thumbnailPath={course.thumbnailPath}
          title={course.title}
          numVideos={course.numVideos}
          duration={course.duration}
          instructorName={course.instructorName}
          isNew={course.isNew}
          containerStyle={{
            height: '100%',
            boxShadow:
              '0px 3.2642054557800293px 16.321027755737305px 0px #0000001A',
          }}
          imageContainerStyle={{ height: '152px' }}
        />
      </ImpressionWatcher>
    );
  });

  return (
    <>
      <Header>New Courses on Academia</Header>
      <CoursesContainer>{items}</CoursesContainer>
      <Link href={routes.courses_path(moreCoursesUrlParams)}>
        <ViewMoreButton>View more Courses</ViewMoreButton>
      </Link>
    </>
  );
};

export default NewCourses;
